import { Component, Input } from '@angular/core';
import { Chart } from 'angular-highcharts';

@Component({
  selector: 'app-graficos-financieros',
  templateUrl: './graficos-financieros.component.html',
  styleUrls: ['./graficos-financieros.component.scss']
})
export class GraficosFinancierosComponent {
  @Input() elementos: string[] = [];
  @Input() elementosClasses: any = {
    'rentabilidad': 'col-sm-12 col-md-6',
    'liquidez': 'col-sm-12 col-md-6',
    'cobertura': 'col-sm-12 col-md-6',
    'eficiencia': 'col-sm-12 col-md-6',
    'estructuraFinanciera': 'col-sm-12',
    'ventasNetas': 'col-sm-12 col-md-6',
    'comprasNetas': 'col-sm-12 col-md-6',
    'comprasVentasNetas': 'col-sm-12'
  };
  //@Input() data: any = null;
  @Input() fromCte: boolean = false;
  @Input() informacionBalance: any[] = [];
  @Input() informacionVentas: any[] = [];

  public rentabilidadGraph: any = {};
  public liquidezGraph: any = {};
  public coberturaGraph: any = {};
  public eficienciaGraph: any = {};
  public estructuraFinancieraGraph: any = {};
  public ventasNetasGraph: any = {};
  public comprasNetasGraph: any = {};
  public comprasVentasNetasGraph: any = {};

  public showReporte: boolean = false;

  ngOnInit(): void {
    this.showReporte = true;
    if(this.informacionBalance && this.informacionBalance.length > 0) {
      this.generateGraphs();
    }
    if(this.informacionVentas && this.informacionVentas.length > 0) {
      this.generateGraphsF29();
    }
  }

  generateGraphs(): void { // informacionBalance -> f22
    if(this.elementos.includes('rentabilidad')) {
      this.setGraficoRentabilidad();
    }
    if(this.elementos.includes('liquidez')) {
      this.setGraficoLiquidez();
    }
    if(this.elementos.includes('cobertura')) {
      this.setGraficoCobertura();
    }
    if(this.elementos.includes('eficiencia')) {
      this.setGraficoEficienciaGraph();
    }
    if(this.elementos.includes('estructuraFinanciera')) {
      this.setGraficoEstructuraFinancieraGraph();
    }
  }

  generateGraphsF29(): void { // reporte o informacionVentas
    if(this.elementos.includes('ventasNetas')) {
      this.setGraficoVentasNetasGraph();
    }
    if(this.elementos.includes('comprasNetas')) {
      this.setGraficoComprasNetasGraph();
    }
    if(this.elementos.includes('comprasVentasNetas')) {
      this.setGraficoComprasVentasNetasGraph();
    }
  }

  setGraficoRentabilidad(): void {
    const VariableColors: string[] = ['#3c64ac', '#4d8cb5', '#62993f', '#a5a5a5'];
    const VariableLabels: any[] = [
      { variable: 'utilidadVentas', percent: true },
      { variable: 'roe', percent: true },
      { variable: 'roa', percent: true }];

    this.rentabilidadGraph = {
      title: 'Evolución Indicadores de Rentabilidad',
      categorias: [{ categories: ['Utilidad / Ventas', 'ROE (%)', 'ROA (%)'] }],
      serie: this.setSerieToGraph(VariableColors, VariableLabels),
      plotOptions: {},
      yAxix: [{
        labels: {
          format: '{value}',
          style: {
            color: '#000'
          }
        },
        title: {
          text: '',
          style: {
            color: '#000'
          }
        }
      }]
    };
  }

  setGraficoLiquidez(): void {
    const VariableColors: string[] = ['#eb7d30', '#569cd8', '#a5a5a5', '#3c64ac'];
    const VariableLabels: any[] = [
      { variable: 'razonCorriente', percent: true },
      { variable: 'testAcido', percent: true },
      { variable: 'permanenciaCtasporCobrar', percent: true },
      { variable: 'permdeCuentasporPagar', percent: true },
    ];

    this.liquidezGraph = {
      title: 'Evolución Indicadores de Liquidez',
      categorias: [{
        categories: ['Razón Corriente (veces)',
          'Test Ácido (veces)',
          'Permanecia Cuentas por Cobrar (días)',
          'Perms de Cuentas por Pagar (días)',
        ]
      }],
      serie: this.setSerieToGraph(VariableColors, VariableLabels),
      plotOptions: {},
      yAxix: [{
        labels: {
          format: '{value}',
          style: {
            color: '#000'
          }
        },
        title: {
          text: '',
          style: {
            color: '#000'
          }
        }
      }]
    };
  }

  setGraficoCobertura(): void {
    const VariableColors: string[] = ['#4b91c4', '#e26627', '#efa689', '#3c64ac'];
    const VariableLabels: any[] = [
      { variable: 'ebitdagf', percent: true },
      { variable: 'leverage', percent: true },
      { variable: 'ingresosdelaExplotacion', variable2: 'totalpasivoexigible', percent: true },
      { variable: 'ingresosdelaExplotacion', variable2: 'totalpatrimonio', percent: true },
    ];
    
    this.coberturaGraph = {
      title: 'Evolución Indicadores de Endeudamiento y Cobertura',
      categorias: [{
        categories: ['EBITDA / GF (veces)',
          'Leverage (veces)',
          'Endeudamiento / Ventas (veces)',
          'Ventas / Patrimonio (veces)',
        ]
      }],
      serie: this.setSerieToGraph(VariableColors, VariableLabels),
      plotOptions: {},
      yAxix: [{
        labels: {
          format: '{value}',
          style: {
            color: '#000'
          }
        },
        title: {
          text: '',
          style: {
            color: '#000'
          }
        }
      }]
    };
  }

  setGraficoEficienciaGraph(): void {
    const VariableColors: string[] = ['#4182bc', '#6faf3f', '#335da9', '#eb7d30'];
    const VariableLabels: any[] = [
      { variable: 'ingresosdelaExplotacion', percent: false },
      { variable: 'ebitda', percent: false },
      { variable: 'gastosFinancieros', percent: false },
      { variable: 'utilidadneta', percent: false }
    ];

    this.eficienciaGraph = {
      title: 'Evolución Indicadores de eficiencia',
      categorias: [{
        categories: ['Ingresos de la Explotación',
          'EBITDA',
          '(Gastos Financieros)',
          'Utilidad Neta',
        ]
      }],
      serie: this.setSerieToGraph(VariableColors, VariableLabels),
      plotOptions: {},
      yAxix: [{
        labels: {
          format: '{value}',
          style: {
            color: '#000'
          }
        },
        title: {
          text: '',
          style: {
            color: '#000'
          }
        }
      }]
    };
  }

  setGraficoEstructuraFinancieraGraph(): void {
    const VariableColors: string[] = ['#deab11', '#bcc1ba', '#3c64ac', '#efa689'];
    const VariableLabels: any[] = [
      { variable: 'totalactivocirculante', percent: false },
      { variable: 'totalactivosfijos', percent: false },
      { variable: 'totalotrosactivospermanentes', percent: false },
      { variable: 'totalpasivoscirculantes', percent: false },
      { variable: 'totalpatrimonio', percent: false }
    ];

    this.estructuraFinancieraGraph = {
      title: 'Estructura Financiera',
      categorias: [{
        categories: [
          'TOTAL ACTIVO CIRCULANTE',
          'TOTAL ACTIVOS FIJOS',
          'TOTAL OTROS ACTIVOS',
          'TOTAL PASIVOS CIRCULANTE',
          'TOTAL PATRIMONIO'
        ]
      }],
      serie: this.setSerieToGraph(VariableColors, VariableLabels),
      plotOptions: {},
      yAxix: [{
        labels: {
          format: '{value}',
          style: {
            color: '#000'
          }
        },
        title: {
          text: '',
          style: {
            color: '#000'
          }
        }
      }]
    };
  }

  setSerieToGraph(colorsSerie: string[], labels: any[], type: string = 'column'): any[] {
    const tempSeries: any = [];
    this.informacionBalance.forEach((element: any, i: number) => {
      tempSeries.push({
        name: element.periodo - 1,
        type: type,
        color: colorsSerie[i],
        data: this.calculateElements(labels, element)
      });
    });
    return tempSeries;
  }

  calculateElements(labels: any[], element: any): any[] {
    const tempData: any[] = [];
    labels.forEach((e: any) => {
      e.variable2? 
      tempData.push(element?.calculado?.[e.variable] && !isNaN(element?.calculado?.[e.variable]) ? (
        !e.percent ?
          element.calculado[e.variable] : Number((element.calculado[e.variable] / element.calculado[e.variable2]).toFixed(2))) : 0)
          :  
      tempData.push(element?.calculado?.[e.variable] && !isNaN(element?.calculado?.[e.variable]) ? (
        !e.percent ?
          element.calculado[e.variable] : Number(element.calculado[e.variable].toFixed(2))) : 0)
    });
    return tempData;
  }

  setGraficoVentasNetasGraph(): void {
    const VariableColors: string[] = ['#4364b3', '#8abaeb', '#5a8430', '#deab11'];
    const VariableLabels: any = { variable: this.fromCte ? 'ventasNetas' : 'ventasNetasMiles', percent: false };
    const chart = new Chart({
      xAxis: [{
        categories: [
          'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
          'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ]
      }],
      title: {
        text: 'Ventas Netas M$'
      },
      yAxis: [{
        labels: {
          format: '{value}',
          style: {
            color: '#000'
          }
        },
        title: {
          text: '',
          style: {
            color: '#000'
          }
        }
      }],
      series: this.setSerieToGraphF29(this.informacionVentas, VariableColors, VariableLabels)
    });
    this.ventasNetasGraph = chart;
  }

  setSerieToGraphF29(informacionVentas: any, colorsSerie: string[], labels: any[]): any[] {
    const tempSeries: any = [];
    informacionVentas.forEach((element: any, i: number) => {
      tempSeries.push({
        name: this.fromCte ? element.date : element.periodo,
        color: colorsSerie[i],
        data: this.calculateElementsF29(labels, this.fromCte ? element.group : element.datosReporte)
      });
    });
    return tempSeries;
  }

  calculateElementsF29(labels: any, element: any): any[] {
    const tempData: any[] = [];
    element.forEach((e: any) => {
      tempData.push(e?.[labels.variable] ? (
        !labels.percent ?
          e[labels.variable] : Number(e[labels.variable].toFixed(2))) : '')
    });
    return tempData;
  }

  setGraficoComprasNetasGraph(): void {
    const VariableColors: string[] = ['#a8a8a8', '#e5c03d', '#4363c8', '#5a8430'];
    const VariableLabels: any = { variable: this.fromCte ? 'comprasNetas' : 'comprasNetasMiles', percent: false };
    const chart = new Chart({
      xAxis: [{
        categories: [
          'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
          'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ]
      }],
      title: {
        text: 'Compras Netas M$'
      },
      yAxis: [{
        labels: {
          format: '{value}',
          style: {
            color: '#000'
          }
        },
        title: {
          text: '',
          style: {
            color: '#000'
          }
        }
      }],
      series: this.setSerieToGraphF29(this.informacionVentas, VariableColors, VariableLabels)
    });
    this.comprasNetasGraph = chart;
  }

  setGraficoComprasVentasNetasGraph(): void {
    const VariableColors: string[] = ['#4364b3', '#959595'];
    const VariableLabels: any = [
      { variable: this.fromCte ? 'ventasNetas' : 'ventasNetasMiles', percent: false },
      { variable: this.fromCte ? 'comprasNetas' : 'comprasNetasMiles', percent: false }
    ];

    const chart = new Chart({
      xAxis: [{
        categories: [
          'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
          'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ]
      }],
      title: {
        text: 'Ventas Netas M$ / Compras Netas M$'
      },
      yAxis: [{
        labels: {
          format: '{value}',
          style: {
            color: '#000'
          }
        },
        title: {
          text: '',
          style: {
            color: '#000'
          }
        }
      }],
      series: this.setSerieToGraphComprasVentasNetas(this.informacionVentas, VariableColors, VariableLabels)
    });
    this.comprasVentasNetasGraph = chart;    
  }

  setSerieToGraphComprasVentasNetas(informacionVentas: any, colorsSerie: string[], labels: any[]): any[] {
    const tempSeries: any = [];

    labels.forEach((value: any, e: number) => {
      [informacionVentas[0]].forEach((element: any, i: number) => {
        tempSeries.push({
          name: this.fromCte ? element.date : element.periodo,
          color: colorsSerie[e],
          data: this.calculateElementsF29(value, this.fromCte ? element.group : element.datosReporte)
        });
      });
    });
    return tempSeries;
  }

  validaData(elemento: string): boolean {
    if (elemento == 'rentabilidad'){
      return this.rentabilidadGraph && this.rentabilidadGraph?.serie;
    } else if (elemento == 'liquidez'){
      return this.liquidezGraph && this.liquidezGraph?.serie;
    } else if (elemento == 'cobertura'){
      return this.coberturaGraph && this.coberturaGraph?.serie;
    } else if (elemento == 'eficiencia'){
      return this.eficienciaGraph && this.eficienciaGraph?.serie;
    } else if (elemento == 'estructuraFinanciera'){
      return this.estructuraFinancieraGraph && this.estructuraFinancieraGraph?.serie;
    } else if (elemento == 'ventasNetas'){
      if(this.ventasNetasGraph) return true;
    } else if (elemento == 'comprasNetas'){
      if(this.comprasNetasGraph) return true;
    } else if (elemento == 'comprasVentasNetas'){
      if(this.comprasVentasNetasGraph) return true;
    }

    return false;
  }

}
